// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.hexagon-container {
  position: relative;
  width: 150px;
  height: 150px;
  margin: 0em auto;
  right: 15px;
  bottom: 20px;
  background: rgba(0, 0, 255, 0);
  z-index: -10;
  display: flex;
  align-items: center;
  justify-content: center;
  clip-path: polygon(27% 10%, 72% 10%, 96% 50%, 72% 90%, 27% 90%, 4% 50%);
}

.segment {
  position: absolute;
  background: transparent;
  width: 62px;
  height: 7px;
  /* bottom: 90px;
  left: 10px; */
  /* clip-path: polygon(0 0, 100% 0, 90% 100%, 10% 100%); */
  transform-origin: center center;
  /* transition: background-color 0.5s ease; */
  border-radius: 10px 10px 0 0;
  --offset: -48px;
}

.segment:nth-child(2) {
  transform: rotate(60deg) translateY(var(--offset));
  z-index: -2;
}

.segment:nth-child(3) {
  transform: rotate(120deg) translateY(var(--offset));
  z-index: -3;
}

.segment:nth-child(4) {
  transform: rotate(180deg) translateY(var(--offset));
  z-index: -4;
}

.segment:nth-child(5) {
  transform: rotate(240deg) translateY(var(--offset));
  z-index: -5;
}

.segment:nth-child(6) {
  transform: rotate(300deg) translateY(var(--offset));
  z-index: -6;
}

.segment:nth-child(1) {
  transform: rotate(360deg) translateY(var(--offset));
  z-index: -1;
}

.segment .start {
  position: absolute;
  width: 10px;
  height: 7px;
  border-radius: 10px;
  background-color: yellow;
  top: 0;
  left: 0;
  z-index: 1;
}`, "",{"version":3,"sources":["webpack://./src/components/HexagonalProgress/index.scss"],"names":[],"mappings":"AAAA;EACI,kBAAA;EACA,YAAA;EACA,aAAA;EACA,gBAAA;EACA,WAAA;EACA,YAAA;EACA,8BAAA;EACA,YAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;EACA,uEAAA;AACJ;;AAKA;EACI,kBAAA;EACA,uBAAA;EACA,WAAA;EACA,WAAA;EACA;eAAA;EAEA,yDAAA;EACA,+BAAA;EACA,4CAAA;EACA,4BAAA;EACA,eAAA;AAFJ;;AAMA;EAAwB,kDAAA;EAAoD,WAAA;AAD5E;;AAEA;EAAwB,mDAAA;EAAqD,WAAA;AAG7E;;AAFA;EAAwB,mDAAA;EAAqD,WAAA;AAO7E;;AANA;EAAwB,mDAAA;EAAqD,WAAA;AAW7E;;AAVA;EAAwB,mDAAA;EAAqD,WAAA;AAe7E;;AAdA;EAAwB,mDAAA;EAAqD,WAAA;AAmB7E;;AAjBA;EACI,kBAAA;EACA,WAAA;EACA,WAAA;EACA,mBAAA;EACA,wBAAA;EACA,MAAA;EACA,OAAA;EACA,UAAA;AAoBJ","sourcesContent":[".hexagon-container {\n    position: relative;\n    width: 150px;\n    height: 150px;\n    margin: 0em auto;\n    right: 15px;\n    bottom: 20px;\n    background: rgba(0, 0, 255, 0);\n    z-index: -10;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    clip-path: polygon(27% 10%, 72% 10%, 96% 50%, 72% 90%, 27% 90%, 4% 50%);\n}\n\n.hexagon-container::before {\n}\n\n.segment {\n    position: absolute;\n    background: transparent;\n    width: 62px;\n    height: 7px;\n    /* bottom: 90px;\n    left: 10px; */\n    /* clip-path: polygon(0 0, 100% 0, 90% 100%, 10% 100%); */\n    transform-origin: center center;\n    /* transition: background-color 0.5s ease; */\n    border-radius: 10px 10px 0 0;\n    --offset: -48px;\n}\n\n\n.segment:nth-child(2) { transform: rotate(60deg) translateY(var(--offset)); z-index: -2;}\n.segment:nth-child(3) { transform: rotate(120deg) translateY(var(--offset)); z-index: -3;}\n.segment:nth-child(4) { transform: rotate(180deg) translateY(var(--offset)); z-index: -4;}\n.segment:nth-child(5) { transform: rotate(240deg) translateY(var(--offset)); z-index: -5;}\n.segment:nth-child(6) { transform: rotate(300deg) translateY(var(--offset)); z-index: -6;}\n.segment:nth-child(1) { transform: rotate(360deg) translateY(var(--offset)); z-index: -1;}\n\n.segment .start {\n    position: absolute;\n    width: 10px;\n    height: 7px;\n    border-radius: 10px;\n    background-color: yellow;\n    top: 0;\n    left: 0;\n    z-index: 1;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
